// extracted by mini-css-extract-plugin
export default {"alert":"alert__c6ab5824","text":"text__c6ab5824","message":"message__c6ab5824","button":"button__c6ab5824","test":"test__c6ab5824"};